"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPulseProviderId = void 0;
const getPulseProviderId = (k) => ({
    AP: "aftenposten",
    ASK: "askoyvaeringen",
    BTI: "bt",
    BYN: "bygdanytt",
    DNB: "aftenposten",
    DP: "dinepenger",
    MPL: "aftenposten-magasin-pluss",
    SA: "stavangeraftenblad",
    SCH: "schibsted",
    STR: "strilen",
    SYS: "sysla",
    VG: "vg",
    VNY: "vestnytt",
    E24: "e24",
    BEDRIFT: "abo-bedrift",
    SVD: "svdse",
    OMNI: "omnise",
    AB: "aftonbladet",
    WELLOBE: "viktklubbse",
    RB24: "randaberg24",
    VEKTKLUBB: "vektklubb",
})[k];
exports.getPulseProviderId = getPulseProviderId;
